import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { MessageValidation } from 'uplisting-frontend/validations';

export default class MessageRepositoryService extends BaseRepositoryService<
  ModelRegistry['message']
> {
  recordName = 'message';
  implementMethods = ['createRecord', 'buildChangeset'];

  validation = MessageValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/message': MessageRepositoryService;
  }
}
